import React from 'react'
import styles from "./Modal.module.css"

const CustomModal = ({ show, children }) => {
    if (!show) {
        return null
    }

    // console.log(show);
    return (

        <div className={styles.modalbackdrop}>
            <div className={styles.modalcontent}>
                {children}
            </div>
        </div>
    )
}

export default CustomModal